<template>
  <h1>Whoops! There's nothing here. Let's go back to the beginning...</h1>
</template>

<script>
export default {
  name: "The404",
  created() {
    // TODO - LOG THIS FOR INVESTIGATION
    setTimeout(() => {
      this.$router.replace("/");
    }, 1000);
  },
};
</script>
